import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'

export const RichPlacement3Section = (): JSX.Element => {
  return (
    <Paper>
      <SectionHeader title={'RichPlacement3Section'} />
    </Paper>
  )
}
